/**
 * Cook Street Introduction
 * 5-Slide Presentation: Title + Content Slides
 */

import { SlideData } from '../../types/slideTypes';

export const slides: SlideData[] = [
  // ============================================
  // SLIDE 1: Title Slide
  // ============================================
  {
    type: 'title',
    isTitle: true,
    title: 'Cook Street Consulting Group',
    subtitle: 'Hitachi Digital Services Introduction',
    presenter: '',
    date: 'November 13, 2025',
  },

  // ============================================
  // SLIDE 2: Introduction - Charley Strickland
  // ============================================
  {
    type: 'content',
    title: 'Charley Strickland: Introduction',
    content: [
      {
        text: 'Founder,',
        boldText: true,
        afterBold:
          ' Cook Street Consulting Group',
      },
      {
        text: 'Senior Executive',
        boldText: true,
        afterBold: ' with 25+ years of experience:',
        subItems: [
          '→ Systems Integration',
          '→ Custom Development',
		  '→ Cloud Infrastructure & Migration',
		  '→ Business Analytics',
		  '→ Supply Chain Optimization',
        ],
      },
      {
        text: 'Diverse Consulting & Software Background:',
        boldText: true,
        afterBold: ' Hitachi Consulting, IBM Business Consulting, & Manhattan Associates',
      },
      {
        text: 'Comprehensive Industry Expertise',
        boldText: true,
        afterBold:
          ' spanning:',
        subItems: [
          '→ Retail & Distribution',
          '→ Oil & Gas',
		  '→ Aerospace & Defense',
		  '→ Process & Discrete Manufacturing',
		  '→ Construction',
		  '→ Utilities',
		  '→ Third-Party Logistics',
        ],
      },
    ],
  },

  // ============================================
  // SLIDE 3: About Cook Street Consulting Group
  // ============================================
  {
    type: 'content',
    title: 'About Cook Street Consulting Group',
    content: [
      {
        text: 'Founded in 2014',
        boldText: true,
        afterBold: ' as a Consulting, Contracting, and Employee Placement Services Firm',
      },
      {
        text: 'Proven Track Record',
        boldText: true,
        afterBold: ' of growth and performance since inception:',
        subItems: [
          '→ $50+ million in revenue',
          '→ 400+ professionals placed across consulting, contracting, and permanent positions',
        ],
      },
      {
        text: 'Global Partnership Network',
        boldText: true,
        afterBold: ' with established relationships across:',
        subItems: [
          '→ Asia Pacific',
          '→ Western & Eastern Europe',
          '→ Central America',
        ],
      },
    ],
  },

  // ============================================
  // SLIDE 4: Service Lines (Custom Component)
  // ============================================
  {
    type: 'custom',
    component: 'ServiceLines',
    title: 'Service Lines',
    props: {},
  },

  // ============================================
  // SLIDE 5: Thank You (Custom Component)
  // ============================================
  {
    type: 'custom',
    component: 'ThankYou',
    title: 'Thank You',
    props: {},
  },
];
